module.exports = __webpack_public_path__ + "static/img/s71.3111e871.png";